import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
import * as React from "react";
import { ProProviders, RedocResponse as RedocResponseOrig } from "@redocly/reference-docs";
import { GetStore } from "../../layouts/MarkdownLayout";
import { RedocComponentWrap } from "./styled.elements";

var OpenApiResponse = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(OpenApiResponse, _React$Component);

  function OpenApiResponse() {
    return _React$Component.apply(this, arguments) || this;
  }

  var _proto = OpenApiResponse.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        a = _this$props.definitionId,
        b = _this$props.pointer,
        c = _this$props.options,
        d = _this$props.hideSamples;
    return /*#__PURE__*/React.createElement(RedocComponentWrap, null, /*#__PURE__*/React.createElement(GetStore, {
      definitionId: a
    }, function (a) {
      return /*#__PURE__*/React.createElement(ProProviders, {
        store: a,
        customOptions: c
      }, /*#__PURE__*/React.createElement(RedocResponseOrig, {
        store: a,
        pointer: b,
        hideSamples: d
      }));
    }));
  };

  return OpenApiResponse;
}(React.Component);

export { OpenApiResponse as default };